import { Link } from "wouter";
import { AlertCircle } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return <div className="min-h-[75vh] flex items-center justify-center bg-pale px-6 pt-32 pb-20">
    <SEO title="Page Not Found | OC Recruitment" description="This page could not be found. Explore OC Recruitment's retained-search services, packaging sectors, hiring insights, or contact Chris Kenny." noindex />
    <div className="max-w-xl rounded border border-border bg-white p-10 text-center">
      <AlertCircle className="mx-auto text-steel mb-6" size={40} aria-hidden="true" />
      <p className="text-steel uppercase tracking-wider text-sm mb-3">404</p>
      <h1 className="text-4xl text-midnight mb-5">Page Not Found</h1>
      <p className="text-slate-brand mb-8 leading-relaxed">The page you requested does not exist or has moved. These links will help you find the right packaging sales recruitment information.</p>
      <div className="flex flex-wrap justify-center gap-4 text-sm text-steel">
        <Link href="/" className="hover:underline">Home</Link>
        <Link href="/for-companies" className="hover:underline">Hire Packaging Sales Talent</Link>
        <Link href="/packaging-sectors" className="hover:underline">Packaging Sectors</Link>
        <Link href="/insights" className="hover:underline">Insights</Link>
        <Link href="/contact" className="hover:underline">Contact Chris</Link>
      </div>
    </div>
  </div>;
}
